import { object as yupObject, string as yupString } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import TranslationMessage from './transMessage'
import { requiredWithoutSpaces } from '../../../utils/regex.utils';
export interface IPracticeInfoFormInput {
    organization_name: string;
    practice_type: string;
    practice_type_specify: string;
    organization_address_1: string;
    organization_address_2: string;
    city: string;
    state: string;
    zip: string;
}

const practiceInfoFormDefaults: IPracticeInfoFormInput = {
    organization_name: '',
    practice_type: '',
    practice_type_specify: '',
    organization_address_1: '',
    organization_address_2: '',
    city: '',
    state: '',
    zip: '',
};

const schema = (t: any) => yupObject({
    organization_name: yupString()
        .min(2, t(TranslationMessage.ERROR_ORGANIZATION_NAME))
        .max(100, t(TranslationMessage.ERROR_ORGANIZATION_NAME))
        .matches(requiredWithoutSpaces(), t(TranslationMessage.ERROR_ORGANIZATION_NAME)) 
        .required(t(TranslationMessage.ERROR_ORGANIZATION_NAME)),
    practice_type_specify: yupString()
        .min(3, t(TranslationMessage.ERROR_PRACTICE_TYPE_SPECIFY))
        .max(20, t(TranslationMessage.ERROR_PRACTICE_TYPE_SPECIFY))
        .matches(requiredWithoutSpaces(), t(TranslationMessage.ERROR_PRACTICE_TYPE_SPECIFY)) 
        .when('practice_type', {
            is: (val: string | null) => val === 'Other',
            then: (schema) => schema.required(t(TranslationMessage.ERROR_PRACTICE_TYPE_SPECIFY)),
            otherwise: (schema) => schema.notRequired().nullable().transform((value) => (value === "" ? null : value))
        }),
    organization_address_1: yupString()
        .min(5, t(TranslationMessage.ERROR_ORGANIZATION_ADDRESS_1))
        .max(200, t(TranslationMessage.ERROR_ORGANIZATION_ADDRESS_1))
        .matches(requiredWithoutSpaces(), t(TranslationMessage.ERROR_ORGANIZATION_ADDRESS_1)) 
        .required(t(TranslationMessage.ERROR_ORGANIZATION_ADDRESS_1)),
    organization_address_2: yupString()
        .max(200, t(TranslationMessage.ERROR_ORGANIZATION_ADDRESS_1))
        .nullable()
        .notRequired(),
    city: yupString()
        .matches(/^[^\d]+$/, t(TranslationMessage.ERROR_CITY))
        .min(3, t(TranslationMessage.ERROR_CITY))
        .max(45, t(TranslationMessage.ERROR_CITY))
        .required(t(TranslationMessage.ERROR_CITY)),
    state: yupString()
        .length(2, t(TranslationMessage.ERROR_STATE))
        .required(t(TranslationMessage.ERROR_STATE)),
    zip: yupString()
        .matches(/^\d+$/, t(TranslationMessage.ERROR_ZIP))
        .length(5, t(TranslationMessage.ERROR_ZIP))
        .required(t(TranslationMessage.ERROR_ZIP)),
});

const infoFormSchemaResolver = (t: any) => yupResolver(schema(t));

const modifyStateList = (data: any[]) => {
    if (Array.isArray(data) && data?.length > 0) {
        const formatedData = data.map((item) => {
            return { label: item?.data?.code, id: item?.data?.name }
        })
        const sortedStateOptions = [...formatedData].sort((a, b) => a?.label?.localeCompare(b?.label));
        return sortedStateOptions
    }
    return []
}

export {
    practiceInfoFormDefaults,
    infoFormSchemaResolver,
    modifyStateList
}